// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

function uncurry6(fn, param) {
  return Curry._6(fn, param[0], param[1], param[2], param[3], param[4], param[5]);
}

function uncurry7(fn, param) {
  return Curry._7(fn, param[0], param[1], param[2], param[3], param[4], param[5], param[6]);
}

function uncurry8(fn, param) {
  return Curry._8(fn, param[0], param[1], param[2], param[3], param[4], param[5], param[6], param[7]);
}

exports.uncurry6 = uncurry6;
exports.uncurry7 = uncurry7;
exports.uncurry8 = uncurry8;
/* No side effect */
